import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header text-white bg-secondary" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted mb-0"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_9 = { class: "d-flex flex-wrap gap-3 mb-3" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_17 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_18 = ["src", "alt", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BButton = _resolveComponent("BButton")
  const _component_BButtonGroup = _resolveComponent("BButtonGroup")
  const _component_BAlert = _resolveComponent("BAlert")
  const _component_Draggable = _resolveComponent("Draggable")
  const _component_ImageViewer = _resolveComponent("ImageViewer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createElementVNode("span", { style: {"font-size":"1.2em"} }, "Bilder", -1 /* CACHED */)),
          ($props.editable)
            ? (_openBlock(), _createBlock(_component_BButtonGroup, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_BButton, {
                    variant: $data.mode === 'add' ? 'dark' : 'secondary',
                    size: "sm",
                    onClick: _cache[0] || (_cache[0] = $event => ($options.switchMode('add')))
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                      _createTextVNode(" Hinzufügen ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["variant"]),
                  _createVNode(_component_BButton, {
                    variant: $data.mode === 'delete' ? 'dark' : 'secondary',
                    size: "sm",
                    disabled: !$data.images.length,
                    onClick: _cache[1] || (_cache[1] = $event => ($options.switchMode('delete')))
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                      _createTextVNode(" Löschen ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["variant", "disabled"]),
                  _createVNode(_component_BButton, {
                    variant: $data.mode === 'reorder' ? 'dark' : 'secondary',
                    size: "sm",
                    disabled: $data.images.length < 2,
                    onClick: _cache[2] || (_cache[2] = $event => ($options.switchMode('reorder')))
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("i", { class: "fa fa-arrows-alt" }, null, -1 /* CACHED */),
                      _createTextVNode(" Reihenfolge ändern ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["variant", "disabled"])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BAlert, {
          modelValue: $options.showError,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($options.showError) = $event)),
          variant: "danger",
          dismissible: "",
          style: {"white-space":"pre-line"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($data.error), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        (!$data.images.length && $data.mode !== 'add')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.emptyMessage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Add mode "),
        ($data.mode === 'add')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("input", {
                ref: "fileInput",
                type: "file",
                class: "form-control mb-3",
                multiple: "",
                accept: "image/*",
                onChange: _cache[4] || (_cache[4] = (...args) => ($options.onFilesSelected && $options.onFilesSelected(...args)))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_BButton, {
                  variant: "secondary",
                  onClick: _cache[5] || (_cache[5] = $event => ($options.switchMode('view')))
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode(" Abbrechen ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_BButton, {
                  variant: "primary",
                  disabled: !$data.selectedFiles.length || $data.saving,
                  onClick: $options.saveUpload
                }, {
                  default: _withCtx(() => [
                    ($data.saving)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                      : _createCommentVNode("v-if", true),
                    _cache[14] || (_cache[14] = _createTextVNode(" Speichern ", -1 /* CACHED */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled", "onClick"])
              ])
            ]))
          : ($data.mode === 'delete')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" Delete mode "),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.images, (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: image.id,
                      class: _normalizeClass(["image-tile image-tile-deletable", { 'marked-for-deletion': $data.markedIds.includes(image.id) }]),
                      onClick: $event => ($options.toggleMark(image.id))
                    }, [
                      _createElementVNode("img", {
                        src: image.url,
                        alt: image.alt
                      }, null, 8 /* PROPS */, _hoisted_11),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "deletion-overlay" }, [
                        _createElementVNode("i", { class: "fa fa-trash-alt" })
                      ], -1 /* CACHED */))
                    ], 10 /* CLASS, PROPS */, _hoisted_10))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_BButton, {
                    variant: "secondary",
                    onClick: _cache[6] || (_cache[6] = $event => ($options.switchMode('view')))
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode(" Abbrechen ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_BButton, {
                    variant: "danger",
                    disabled: !$data.markedIds.length || $data.saving,
                    onClick: $options.saveDelete
                  }, {
                    default: _withCtx(() => [
                      ($data.saving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                        : _createCommentVNode("v-if", true),
                      _createTextVNode(" " + _toDisplayString($data.markedIds.length ? `${$data.markedIds.length} Bild(er) löschen` : 'Löschen'), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "onClick"])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : ($data.mode === 'reorder')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createCommentVNode(" Reorder mode "),
                  _createVNode(_component_Draggable, {
                    modelValue: $data.reorderingImages,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.reorderingImages) = $event)),
                    class: "d-flex flex-wrap gap-3 mb-3",
                    animation: 200,
                    "ghost-class": "ghost"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.reorderingImages, (image) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: image.id,
                          class: "image-tile image-tile-draggable"
                        }, [
                          _createElementVNode("img", {
                            src: image.url,
                            alt: image.alt
                          }, null, 8 /* PROPS */, _hoisted_14)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_BButton, {
                      variant: "secondary",
                      onClick: _cache[8] || (_cache[8] = $event => ($options.switchMode('view')))
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" Abbrechen ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_BButton, {
                      variant: "primary",
                      disabled: $data.saving,
                      onClick: $options.saveReorder
                    }, {
                      default: _withCtx(() => [
                        ($data.saving)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                          : _createCommentVNode("v-if", true),
                        _cache[18] || (_cache[18] = _createTextVNode(" Speichern ", -1 /* CACHED */))
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled", "onClick"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createCommentVNode(" View mode "),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.images, (image, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: image.id,
                        class: "image-tile"
                      }, [
                        _createElementVNode("img", {
                          src: image.url,
                          alt: image.alt,
                          style: {"cursor":"pointer"},
                          onClick: $event => (_ctx.$refs.imageViewer.openImages($data.images, $props.viewTitle, index))
                        }, null, 8 /* PROPS */, _hoisted_18)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      ])
    ]),
    _createVNode(_component_ImageViewer, { ref: "imageViewer" }, null, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}